var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.351,
    height: 69.15,
    viewBox: "0 0 131.351 69.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-8.133 -33.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M131.673,6.208h17.189V9.1h6.208V5.8a5.807,5.807,0,0,0-5.8-5.8h-18a5.808,5.808,0,0,0-5.8,5.8V9.1h6.208Zm0,0",
    transform: "translate(15.759 -38.208) rotate(42)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M101.5,167.75H43.224A2.734,2.734,0,0,0,40.5,170.7l4.872,60.243a6.47,6.47,0,0,0,6.447,5.953H92.9a6.47,6.47,0,0,0,6.447-5.954l4.872-60.242A2.733,2.733,0,0,0,101.5,167.75ZM57.335,230.475c-.065,0-.13.006-.195.006a3.1,3.1,0,0,1-3.095-2.913l-3.053-49.456a3.1,3.1,0,1,1,6.2-.382l3.052,49.456A3.1,3.1,0,0,1,57.335,230.475Zm18.166-3.1a3.1,3.1,0,0,1-6.208,0V177.92a3.1,3.1,0,1,1,6.208,0ZM93.731,178.1l-2.915,49.456a3.1,3.1,0,0,1-3.1,2.921c-.061,0-.123,0-.185,0a3.1,3.1,0,0,1-2.916-3.281l2.914-49.457a3.1,3.1,0,1,1,6.2.366Zm0,0",
    transform: "translate(-32.357 -134.054)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M79.877,85.019l-2.039-6.111a3.947,3.947,0,0,0-3.744-2.7H5.916a3.946,3.946,0,0,0-3.744,2.7L.134,85.019A2.564,2.564,0,0,0,2.563,88.39H77.448A2.528,2.528,0,0,0,78.8,88,2.557,2.557,0,0,0,79.877,85.019Zm0,0",
    transform: "translate(131.02 -16.379) rotate(42)",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.42f8898b47bf2e493e99bcd2051251a5.svg";
export { ForwardRef as ReactComponent };